import { createSelector } from '../../../utils/createSelector';

/**
 * @category ColumnGrouping
 * @ignore - do not document.
 */
export const gridColumnGroupingSelector = state => state.columnGrouping;
export const gridColumnGroupsLookupSelector = createSelector(gridColumnGroupingSelector, columnGrouping => columnGrouping.lookup);


//////////////////
// WEBPACK FOOTER
// ../@mui/x-data-grid/hooks/features/columnGrouping/gridColumnGroupsSelector.js
// module id = 639
// module chunks = 25